var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileEarmarkText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-earmark-text",
    transform: "translate(-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12856",
    "data-name": "Group 12856",
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12778",
    "data-name": "Path 12778",
    d: "M15.583,21a.563.563,0,1,0,0,1.125h5.833a.563.563,0,1,0,0-1.125ZM15,23.813a.573.573,0,0,1,.583-.562h5.833a.563.563,0,1,1,0,1.125H15.583A.573.573,0,0,1,15,23.813Zm0,2.25a.573.573,0,0,1,.583-.562h2.333a.563.563,0,1,1,0,1.125H15.583A.573.573,0,0,1,15,26.063Z",
    transform: "translate(-11.5 -13.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12779",
    "data-name": "Path 12779",
    d: "M14.75,0H8.333A2.293,2.293,0,0,0,6,2.25v13.5A2.293,2.293,0,0,0,8.333,18h9.333A2.293,2.293,0,0,0,20,15.75V5.063Zm0,1.125v2.25A1.72,1.72,0,0,0,16.5,5.063h2.333V15.75a1.146,1.146,0,0,1-1.167,1.125H8.333A1.146,1.146,0,0,1,7.167,15.75V2.25A1.146,1.146,0,0,1,8.333,1.125Z",
    transform: "translate(-6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEarmarkText);
export default __webpack_public_path__ + "static/media/file-earmark-text.f962d3eb1d8734f0f84e1812756a85cb.svg";
export { ForwardRef as ReactComponent };